module.exports = __webpack_public_path__ + "media/header-fr.8097cb3f.mp4";